import styles from './SuperlikeMessage.module.scss';

export type SuperlikeMessageProps = {
  message: string;
};

/**
 * The sender's message on an incoming superlike card (board 2.1): plain
 * text in a glass bubble, hidden from session recordings.
 */
export const SuperlikeMessage = ({ message }: SuperlikeMessageProps) => (
  <p
    className={`${styles.superlikeMessage} ym-hide-content`}
    data-test-id="superlike-message"
  >
    {message}
  </p>
);
